import endOfWeek from 'date-fns/endOfWeek';
import isSameDay from 'date-fns/isSameDay';
import isSameWeek from 'date-fns/isSameWeek';
import isLastDayOfMonth from 'date-fns/isLastDayOfMonth';
import isFirstDayOfMonth from 'date-fns/isFirstDayOfMonth';
import isWithinInterval from 'date-fns/isWithinInterval';
import startOfWeek from 'date-fns/startOfWeek';
import { isAfter, isBefore } from 'date-fns';

const getSelectedStyle = (date, [start, end], options = {}) => {
    const { hoveredDate, isStart, hasSelection, startAndEndWeekSame } = options;
    const isWithinStartWeek = start && end && isWithinInterval(date, { start, end });
    if (isWithinStartWeek) {
        let className = 'selectedDay';
        if (isFirstDayOfMonth(date) || isSameDay(start, date)) {
            className += ' withLeftBorder';
            if (isStart || isFirstDayOfMonth(date)) {
                className += ' leftRounded';
            }
        }
        if (isLastDayOfMonth(date) || isSameDay(end, date)) {
            className += ' withRightBorder';
            const isHoveredAfter = hoveredDate && isAfter(hoveredDate, end);
            if (startAndEndWeekSame || (!isHoveredAfter && !hasSelection) || isLastDayOfMonth(date)) {
                className += ' rightRounded';
            }
        }
        return className;
    }
};
const getHoveredClassName = (date, hoveredDate, startWeek, endWeek, weekStartsOn) => {
    let className = 'withinWeekRange';
    const hoveredWeekStart = startOfWeek(hoveredDate, { weekStartsOn });
    const hoveredWeekEnd = endOfWeek(hoveredDate, { weekStartsOn });
    const isAfterSelection = !!(endWeek === null || endWeek === void 0 ? void 0 : endWeek.end) && isAfter(date, endWeek.end);
    const isBeforeSelection = !!startWeek.start && isBefore(date, startWeek.start);
    const isOutsideSelection = isAfterSelection || isBeforeSelection;
    const startDay = isOutsideSelection ? hoveredWeekStart : startWeek.start || hoveredWeekStart;
    if (isFirstDayOfMonth(date) || isSameDay(startDay, date)) {
        className = `${className} leftRounded`;
    }
    const endDay = isOutsideSelection ? hoveredWeekEnd : endWeek.end || hoveredWeekEnd;
    if (isLastDayOfMonth(date) || isSameDay(endDay, date)) {
        className = `${className} rightRounded`;
    }
    return className;
};
const getWeeksClassName = (date, startWeek, endWeek, weekStartsOn, hoveredDate) => {
    const startWeekArray = [startWeek.start, startWeek.end];
    const startAndEndWeekSame = !!startWeek.end && !!endWeek.end && isSameDay(startWeek.end, endWeek.end);
    const startSelectedWeekStyle = getSelectedStyle(date, startWeekArray, {
        hoveredDate,
        isStart: true,
        hasSelection: !!endWeek.start,
        startAndEndWeekSame,
    });
    if (startSelectedWeekStyle) {
        return startSelectedWeekStyle;
    }
    const endWeekArray = [endWeek.start, endWeek.end];
    const endSelectedWeekStyle = getSelectedStyle(date, endWeekArray);
    if (endSelectedWeekStyle) {
        return endSelectedWeekStyle;
    }
    if (hoveredDate && isSameWeek(hoveredDate, date, { weekStartsOn })) {
        return getHoveredClassName(date, hoveredDate, startWeek, endWeek, weekStartsOn);
    }
    if (isFirstDayOfMonth(date)) {
        return 'leftRounded';
    }
    if (isLastDayOfMonth(date)) {
        return 'rightRounded';
    }
    return null;
};

export { getWeeksClassName };
//# sourceMappingURL=getWeeksClassName.js.map
